export default __webpack_public_path__ + "static/media/fAQ.9e6f2c6c.svg";